import "swizi";
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import store from "./services/redux/configureStore";
import moment from "moment";
import { ConfigProvider, Modal } from "antd";
import enUS from "antd/lib/locale/en_US";
import frFR from "antd/lib/locale/fr_FR";
import nlBE from "antd/lib/locale/nl_BE";
import "moment/locale/fr";

import i18n from "./i18n/i18n";

import "./styles/index.less";
import "./styles/antd.less";
import "./index.css";

import Routes from "./Routes";

//Design Token
import colors from "@tokens/web/colors.json";

const antLocales = {
  fr: frFR,
  en: enUS,
  nl: nlBE,
};

const language = localStorage.getItem("i18nextLng");

const root = document.querySelector(":root");

root.style.setProperty("--main-color", colors.primary_base);
root.style.setProperty("--second-color", colors.secondary_base);
root.style.setProperty("--third-color", colors.interactive_03);
root.style.setProperty("--black", colors.primary_dark);

const App = ({ token, acmConf }) => {
  const lng = i18n.language.split("-")[0];

  useEffect(() => {
    if (language === "fr") {
      moment.locale("fr");
    }
  }, [language]);

  return (
    <Provider store={store}>
      <ConfigProvider componentSize="large" locale={antLocales[lng]}>
        <Router
          getUserConfirmation={(message, callback) => {
            Modal.confirm({
              title: message,
              onOk() {
                return callback(true);
              },
              onCancel() {
                return callback(false);
              },
            });
          }}
        >
          <Routes />
        </Router>
      </ConfigProvider>
    </Provider>
  );
};

export default App;
